import React from 'react'

export default function index() {
  return (
    <div>
      首页
    </div>
  )
}
